export interface googleAdOptions {
  id: MaybeRef<Maybe<string>>
  code: MaybeRef<Maybe<string>>
  baseUnit: MaybeRef<Maybe<string>>
  index?: number | string
}

export const useGoogleAdParams = (options: googleAdOptions) => {
  const {
    id: idRef,
    code: coreRef,
    baseUnit: baseUnitRef,
    index = 0,
  } = options

  const unit = computed<Maybe<string>>(() => {
    const id = unref(idRef)
    const code = unref(coreRef)
    const baseUnit = unref(baseUnitRef)

    if (!id || !code || !baseUnit) {
      return null
    }

    return unref(baseUnit)
      .replace('$id', `${unref(id)}`)
      .replace('$code', unref(code))
  })

  const elementId = computed<Maybe<string>>(() => {
    const id = unref(idRef)
    const code = unref(coreRef)

    if (!id || !code) {
      return null
    }

    return `gpt-ad-${id}-${index}`
  })

  return {
    unit,
    elementId,
  }
}
